__turbopack_context__.v({
  "label": "mpH7Va_label",
  "paused": "mpH7Va_paused",
  "ticker": "mpH7Va_ticker",
});
